module.exports = __webpack_public_path__ + "static/media/aisha.afab040b.jpg";